import css from "styled-jsx/css";
import { FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import { TOP_LAYER } from "constants/z-index";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";

const HEADER_CONTENT_HORIZONTAL_PADDING = `${Constants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
const FULL_SCREEN_LEFT_PADDING = "24px";
const ARROW_WIDTH = "23px";
const ARROW_MARGIN = "16px";

export const componentStyles = css.global`
  .sliding-card-grid-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;
    padding: 32px ${HEADER_CONTENT_HORIZONTAL_PADDING};

    &.full-carousel-width {
      max-width: ${`${FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
      padding-left: ${`calc(max(min(100vw, ${FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px, 0px) / 2 + ${HEADER_CONTENT_HORIZONTAL_PADDING})`};
    }

    &.full-screen {
      max-width: ${`${FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
      padding-right: 0;
      padding-left: 24px;

      .carousel-arrow-wrapper {
        &.next {
          left: ${`calc(50% - ${FULL_SCREEN_LEFT_PADDING})`};
        }

        &.prev {
          left: ${`calc(50% - ${FULL_SCREEN_LEFT_PADDING} - ${ARROW_WIDTH})`};
        }
      }
    }

    .carousel {
      .slick-slider {
        .slick-list {
          .slick-track {
            display: flex;
            padding-bottom: 80px;

            .slick-slide {
              height: auto;

              > div:first-child {
                height: 100%;
              }
            }

            .carousel-item {
              height: 100%;

              .card-grid-link {
                .grid-paragraph-with-image {
                  cursor: grab;
                  width: fit-content;
                  border-radius: 8px;
                  margin-right: 24px;
                  min-height: 100%;

                  .grid-paragraph-wrapper {
                    display: flex;
                  }
                }
              }
            }
          }
        }
      }
    }

    .carousel-arrow-wrapper {
      top: auto;
      position: absolute;
      bottom: 0;
      z-index: ${TOP_LAYER};
      height: fit-content;
      width: fit-content;

      &.next {
        left: 50%;
        margin-left: ${ARROW_MARGIN};

        &::before {
          content: none;
        }
      }

      &.prev {
        left: ${`calc(50% - ${ARROW_WIDTH})`};
        margin-left: ${`-${ARROW_MARGIN}`};

        &::before {
          content: none;
        }
      }
    }
  }
`;
